/**
 * Provenance for every photograph on the page. Each name links to the original
 * photograph page rather than the raw image file, per the shortlist guidance.
 */
export const PHOTO_CREDITS = [
  {
    title: 'Friends Riding in a Van',
    photographer: 'RDNE Stock project',
    platform: 'Pexels',
    href: 'https://www.pexels.com/photo/close-up-shot-of-friends-riding-a-car-7464537/',
    licenceHref: 'https://www.pexels.com/license/',
  },
  {
    title: 'African Men in a Car',
    photographer: 'Muhammad-Taha Ibrahim',
    platform: 'Pexels',
    href: 'https://www.pexels.com/photo/african-men-in-a-car-4663028/',
    licenceHref: 'https://www.pexels.com/license/',
  },
  {
    title: 'Vehicles on a Highway',
    photographer: 'Maureen Wahu',
    platform: 'Pexels',
    href: 'https://www.pexels.com/photo/vehicles-on-a-highway-10154857/',
    licenceHref: 'https://www.pexels.com/license/',
  },
  {
    title: 'Road in Kenya',
    photographer: 'Sweder Breet',
    platform: 'Unsplash',
    href: 'https://unsplash.com/photos/a-long-empty-road-with-a-sky-background--eIlr1CVbmE',
    licenceHref: 'https://unsplash.com/license',
  },
  {
    title: 'Nyali Beach',
    photographer: 'Wendy Brooks',
    platform: 'Unsplash',
    href: 'https://unsplash.com/photos/two-silhouette-of-people-walking-on-seaside-sNOlOUXquTw',
    licenceHref: 'https://unsplash.com/license',
  },
  {
    title: 'Road Trip with Friends',
    photographer: 'Andrea Piacquadio',
    platform: 'Pexels',
    href: 'https://www.pexels.com/photo/road-trip-with-friends-3989923/',
    licenceHref: 'https://www.pexels.com/license/',
  },
];
